"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableFilterTypes;
(function (TableFilterTypes) {
    TableFilterTypes[TableFilterTypes["Text"] = 0] = "Text";
    TableFilterTypes[TableFilterTypes["Select"] = 1] = "Select";
    TableFilterTypes[TableFilterTypes["Flag"] = 2] = "Flag";
    TableFilterTypes[TableFilterTypes["Date"] = 3] = "Date";
    TableFilterTypes[TableFilterTypes["DateRange"] = 4] = "DateRange";
})(TableFilterTypes = exports.TableFilterTypes || (exports.TableFilterTypes = {}));
class FilterOption {
    constructor(value, label = String(value)) {
        this.value = value;
        this.label = label;
    }
}
exports.FilterOption = FilterOption;
class TableFilterModel {
    constructor(name, label = '', type = TableFilterTypes.Text, options = [], shownByDefault = true, styleOptions = { span: 8, withoutLabel: false }) {
        this.name = name;
        this.label = label;
        this.type = type;
        this.options = options;
        this.shownByDefault = shownByDefault;
        this.styleOptions = styleOptions;
    }
}
exports.TableFilterModel = TableFilterModel;
//# sourceMappingURL=TableFilterModel.js.map